import { useLocation } from 'react-router-dom'

/**
 * UseQuery - custom hook used to return new URLSearchParams object based on useLocation().search from react router
 * @return {object}
 */
const useQuery = () => new URLSearchParams(useLocation().search)

export default useQuery
